module.exports = __webpack_public_path__ + "img/C.af5637a8.jpg";